import { useState } from 'react';

const useInputBoxes = () => {
  const [inputBoxes, setInputBoxes] = useState([]);
  const [momentBoxes, setMomentBoxes] = useState([]);

  // 初始化输入框
  const initializeInputBoxes = (stepType = 'MESSAGE') => {
    if (stepType === 'MESSAGE') {
      setInputBoxes([
        { id: 'text-' + Date.now(), type: 'TEXT' }
      ]);
    } else if (stepType === 'MOMENTS') {
      setMomentBoxes([
        { id: 'moment-text-' + Date.now(), type: 'MOMENT_TEXT' }
      ]);
    }
  };

  // 更新输入框内容
  const updateInputBoxContent = (id, fieldName, value, stepType = 'MESSAGE') => {
    if (stepType === 'MESSAGE') {
      setInputBoxes(boxes => 
        boxes.map(box => 
          box.id === id ? { ...box, [fieldName]: value } : box
        )
      );
    } else if (stepType === 'MOMENTS') {
      setMomentBoxes(boxes => 
        boxes.map(box => 
          box.id === id ? { ...box, [fieldName]: value } : box
        )
      );
    }
  };

  // 更新输入框类型
  const updateInputBoxType = (id, type, stepType = 'MESSAGE') => {
    if (stepType === 'MESSAGE') {
      setInputBoxes(boxes => 
        boxes.map(box => 
          box.id === id ? { 
            ...box, 
            type, 
            mediaId: '', 
            videoMediaId: '', 
            fileMediaId: '' 
          } : box
        )
      );
    } else if (stepType === 'MOMENTS') {
      setMomentBoxes(boxes => 
        boxes.map(box => 
          box.id === id ? { 
            ...box, 
            type, 
            mediaId: '' 
          } : box
        )
      );
    }
  };

  // 添加输入框
  const addInputBox = (currentType = 'TEXT', stepType = 'MESSAGE') => {
    const newBox = {
      id: `${stepType.toLowerCase()}-${currentType.toLowerCase()}-${Date.now()}`,
      type: currentType
    };

    if (currentType === 'TEXT' || currentType === 'MOMENT_TEXT') {
      newBox.content = '';
    }

    if (stepType === 'MESSAGE') {
      setInputBoxes(boxes => [...boxes, newBox]);
    } else if (stepType === 'MOMENTS') {
      setMomentBoxes(boxes => [...boxes, newBox]);
    }
  };

  // 删除输入框 (当前保持不允许删除的逻辑)
  const removeInputBox = (id, stepType = 'MESSAGE') => {
    // 保持原有逻辑：不允许删除，保持固定的两个框
    console.warn('不允许删除输入框，保留文本和多媒体框');
    return false;
  };

  // 从messageList恢复输入框状态
  const restoreFromMessageList = (messageList) => {
    if (!messageList || messageList.length === 0) {
      initializeInputBoxes('MESSAGE');
      return;
    }

    // 处理图片组合逻辑
    const groupedImages = {};
    const normalMessages = [];
    const imageMessages = [];
    const nonImageMessages = [];
    
    // 分离图片消息和非图片消息
    messageList.forEach(message => {
      if (message.type === 'IMAGE') {
        imageMessages.push(message);
      } else if (message.type !== 'IMAGE_GROUP') {
        nonImageMessages.push(message);
      }
    });
    
    // 识别应该组合的图片集
    const standardGroupedImages = {};
    const remainingImages = [];
    
    imageMessages.forEach(message => {
      if (message.id && message.id.includes('-img-')) {
        const originalId = message.id.substring(0, message.id.lastIndexOf('-img-'));
        
        if (!standardGroupedImages[originalId]) {
          standardGroupedImages[originalId] = {
            id: originalId,
            type: 'IMAGE_GROUP',
            params: {
              imageGroup: {
                mediaIds: [],
                ossUrls: {}
              }
            },
            images: []
          };
        }
        
        standardGroupedImages[originalId].images.push(message);
        
        const mediaId = message.params.mediaId;
        const ossUrl = message.params.ossUrl;
        
        if (mediaId) {
          standardGroupedImages[originalId].params.imageGroup.mediaIds.push(mediaId);
          standardGroupedImages[originalId].params.imageGroup.ossUrls[mediaId] = ossUrl || '';
        }
      } else {
        remainingImages.push(message);
      }
    });
    
    // 处理剩余图片
    if (remainingImages.length > 0) {
      const groupId = `img-group-${Date.now()}`;
      const combinedGroup = {
        id: groupId,
        type: 'IMAGE_GROUP',
        params: {
          imageGroup: {
            mediaIds: [],
            ossUrls: {}
          }
        },
        images: remainingImages
      };
      
      remainingImages.forEach(image => {
        const mediaId = image.params.mediaId;
        const ossUrl = image.params.ossUrl;
        
        if (mediaId) {
          combinedGroup.params.imageGroup.mediaIds.push(mediaId);
          combinedGroup.params.imageGroup.ossUrls[mediaId] = ossUrl || '';
        }
      });
      
      if (combinedGroup.params.imageGroup.mediaIds.length > 0) {
        standardGroupedImages[groupId] = combinedGroup;
      }
    }
    
    // 合并所有消息
    const combinedMessages = [
      ...nonImageMessages,
      ...Object.values(standardGroupedImages)
    ];

    // 转换为输入框数据
    const boxes = combinedMessages.map(message => {
      const box = {
        id: message.id || `msg-${Date.now()}-${Math.random()}`,
        type: message.type,
        ...message.params
      };

      // 处理特殊字段
      if (['IMAGE', 'VIDEO', 'FILE'].includes(message.type)) {
        if (message.params.mediaId) {
          box.mediaId = message.params.mediaId;
          
          if (message.params.ossUrl || message.params.mediaId_ossUrl) {
            box.ossUrl = message.params.ossUrl || message.params.mediaId_ossUrl;
          }
        }
      } else if (message.type === 'IMAGE_GROUP') {
        // 处理图片组类型 - 确保imageGroup数据被保留
        if (message.params.imageGroup) {
          box.imageGroup = message.params.imageGroup;
        }
      } else if (message.type === 'MINIPROGRAM') {
        // 专门处理小程序类型
        if (message.params.thumbMediaId) {
          box.thumbMediaId = message.params.thumbMediaId;
          
          if (message.params.thumbMediaId_ossUrl) {
            box.thumbMediaId_ossUrl = message.params.thumbMediaId_ossUrl;
          }
        }
        
        // 复制其他小程序字段
        if (message.params.title) box.title = message.params.title;
        if (message.params.appid) box.appid = message.params.appid;
        if (message.params.pagepath) box.pagepath = message.params.pagepath;
      }

      return box;
    });

    // 确保有文本框
    const hasTextBox = boxes.some(box => box.type === 'TEXT');

    if (!hasTextBox) {
      boxes.unshift({
        id: `text-${Date.now()}`,
        type: 'TEXT',
        content: ''
      });
    }

    setInputBoxes(boxes);
  };

  // 从momentsList恢复朋友圈输入框状态
  const restoreFromMomentsList = (momentsList) => {
    if (!momentsList || momentsList.length === 0) {
      initializeInputBoxes('MOMENTS');
      return;
    }

    // 类似的图片组合逻辑
    const groupedImages = {};
    const normalMoments = [];
    
    momentsList.forEach(moment => {
      if (moment.type === 'MOMENT_IMAGE' && moment.id.includes('-img-')) {
        const originalId = moment.id.substring(0, moment.id.lastIndexOf('-img-'));
        
        if (!groupedImages[originalId]) {
          groupedImages[originalId] = {
            id: originalId,
            type: 'MOMENT_IMAGE_GROUP',
            params: {
              imageGroup: {
                mediaIds: [],
                ossUrls: {}
              }
            },
            images: []
          };
        }
        
        groupedImages[originalId].images.push(moment);
        
        const mediaId = moment.params.mediaId;
        const ossUrl = moment.params.ossUrl;
        
        if (mediaId) {
          groupedImages[originalId].params.imageGroup.mediaIds.push(mediaId);
          groupedImages[originalId].params.imageGroup.ossUrls[mediaId] = ossUrl || '';
        }
      } else {
        normalMoments.push(moment);
      }
    });
    
    const combinedMoments = [
      ...normalMoments,
      ...Object.values(groupedImages)
    ];

    const boxes = combinedMoments.map(moment => {
      const box = {
        id: moment.id || `moment-${Date.now()}-${Math.random()}`,
        type: moment.type,
        ...moment.params
      };

      if (['MOMENT_IMAGE', 'MOMENT_VIDEO'].includes(moment.type)) {
        if (moment.params.mediaId) {
          box.mediaId = moment.params.mediaId;
          
          if (moment.params.ossUrl || moment.params.mediaId_ossUrl) {
            box.ossUrl = moment.params.ossUrl || moment.params.mediaId_ossUrl;
          }
        }
      } else if (moment.type === 'MOMENT_IMAGE_GROUP') {
        // 处理朋友圈图片组类型 - 确保imageGroup数据被保留
        if (moment.params.imageGroup) {
          box.imageGroup = moment.params.imageGroup;
        }
      }

      return box;
    });

    // 确保有文本框
    const hasTextBox = boxes.some(box => box.type === 'MOMENT_TEXT');

    if (!hasTextBox) {
      boxes.unshift({
        id: `moment-text-${Date.now()}`,
        type: 'MOMENT_TEXT',
        content: ''
      });
    }

    setMomentBoxes(boxes);
  };

  return {
    inputBoxes,
    momentBoxes,
    setInputBoxes,
    setMomentBoxes,
    initializeInputBoxes,
    updateInputBoxContent,
    updateInputBoxType,
    addInputBox,
    removeInputBox,
    restoreFromMessageList,
    restoreFromMomentsList
  };
};

export default useInputBoxes; 